import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RoomTypeDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class RoomTypeApiClient extends BaseCRUDApiClient<RoomTypeDtoModel> {
  baseUrl = this.config.apiEndpoint + '/room-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
